// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"3d45d1b7","351":"1bbeb21d","451":"08d75872"}[chunkId] + ".chunk.js";
};